var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createEffect, createSignal } from 'solid-js';
import { Anchor, Button, Container, Input, Label, Message } from '../../UI';
var VIEWS = {
    SIGN_IN: 'sign_in',
    SIGN_UP: 'sign_up',
    FORGOTTEN_PASSWORD: 'forgotten_password',
    MAGIC_LINK: 'magic_link',
    UPDATE_PASSWORD: 'update_password'
};
function EmailAuth(props) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var _u = createSignal(true), isMounted = _u[0], setIsMounted = _u[1];
    var _v = createSignal(props.defaultEmail), email = _v[0], setEmail = _v[1];
    var _w = createSignal(props.defaultPassword), password = _w[0], setPassword = _w[1];
    var _x = createSignal(''), error = _x[0], setError = _x[1];
    var _y = createSignal(false), loading = _y[0], setLoading = _y[1];
    var _z = createSignal(''), message = _z[0], setMessage = _z[1];
    createEffect(function () {
        setEmail(props.defaultEmail);
        setPassword(props.defaultPassword);
        return function () {
            setIsMounted(function () { return false; });
        };
    });
    var handleSubmit = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var _a, signInError, options, _b, _c, signUpUser, signUpSession, signUpError;
        var _d;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    e.preventDefault();
                    setError('');
                    setLoading(true);
                    _a = props.authView;
                    switch (_a) {
                        case 'sign_in': return [3 /*break*/, 1];
                        case 'sign_up': return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 5];
                case 1: return [4 /*yield*/, props.supabaseClient.auth.signInWithPassword({
                        email: email(),
                        password: password()
                    })];
                case 2:
                    signInError = (_e.sent()).error;
                    if (signInError)
                        setError(signInError.message);
                    return [3 /*break*/, 5];
                case 3:
                    options = {
                        emailRedirectTo: props.redirectTo
                    };
                    if (props.additionalData) {
                        options.data = props.additionalData;
                    }
                    return [4 /*yield*/, props.supabaseClient.auth.signUp({
                            email: email(),
                            password: password(),
                            options: options
                        })];
                case 4:
                    _b = _e.sent(), _c = _b.data, signUpUser = _c.user, signUpSession = _c.session, signUpError = _b.error;
                    if (signUpError)
                        setError(signUpError.message);
                    // Check if session is null -> email confirmation setting is turned on
                    else if (signUpUser && !signUpSession)
                        setMessage((_d = props.i18n.sign_up) === null || _d === void 0 ? void 0 : _d.confirmation_text);
                    return [3 /*break*/, 5];
                case 5:
                    /*
                     * it is possible the auth component may have been unmounted at this point
                     * check if component is mounted before setting a useState
                     */
                    if (isMounted())
                        setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleViewChange = function (newView) {
        props.setDefaultEmail(email());
        props.setDefaultPassword(password());
        props.setAuthView(newView);
    };
    return (<form id={props.authView === 'sign_in' ? "auth-sign-in" : "auth-sign-up"} onSubmit={handleSubmit} autocomplete={'on'} style={{ width: '100%' }}>
      <Container direction="vertical" gap="large" appearance={props.appearance}>
        <Container direction="vertical" gap="large" appearance={props.appearance}>
          <div>
            <Label for="email" appearance={props.appearance}>
              {(_b = (_a = props.i18n) === null || _a === void 0 ? void 0 : _a[props.authView]) === null || _b === void 0 ? void 0 : _b.email_label}
            </Label>
            <Input id="email" type="email" name="email" autofocus placeholder={(_d = (_c = props.i18n) === null || _c === void 0 ? void 0 : _c[props.authView]) === null || _d === void 0 ? void 0 : _d.email_input_placeholder} value={email()} onkeyup={function (e) { return setEmail(function () { return e.currentTarget.value; }); }} autocomplete="email" appearance={props.appearance}/>
          </div>
          <div>
            <Label for="password" appearance={props.appearance}>
              {(_f = (_e = props.i18n) === null || _e === void 0 ? void 0 : _e[props.authView]) === null || _f === void 0 ? void 0 : _f.password_label}
            </Label>
            <Input id="password" type="password" name="password" placeholder={(_h = (_g = props.i18n) === null || _g === void 0 ? void 0 : _g[props.authView]) === null || _h === void 0 ? void 0 : _h.password_input_placeholder} value={password()} onkeyup={function (e) { return setPassword(function () { return e.currentTarget.value; }); }} autocomplete={props.authView === 'sign_in'
            ? 'current-password'
            : 'new-password'} appearance={props.appearance}/>
          </div>
          {props.children}
        </Container>

        <Button type="submit" color="primary" loading={loading()} appearance={props.appearance}>
          {(_k = (_j = props.i18n) === null || _j === void 0 ? void 0 : _j[props.authView]) === null || _k === void 0 ? void 0 : _k.button_label}
        </Button>

        {props.showLinks && (<Container direction="vertical" gap="small" appearance={props.appearance}>
            {props.authView === VIEWS.SIGN_IN && props.magicLink && (<Anchor href="#auth-magic-link" onClick={function (e) {
                    e.preventDefault();
                    props.setAuthView(VIEWS.MAGIC_LINK);
                }} appearance={props.appearance}>
                {(_m = (_l = props.i18n) === null || _l === void 0 ? void 0 : _l.magic_link) === null || _m === void 0 ? void 0 : _m.link_text}
              </Anchor>)}
            {props.authView === VIEWS.SIGN_IN && (<Anchor href="#auth-forgot-password" onClick={function (e) {
                    e.preventDefault();
                    props.setAuthView(VIEWS.FORGOTTEN_PASSWORD);
                }} appearance={props.appearance}>
                {(_p = (_o = props.i18n) === null || _o === void 0 ? void 0 : _o.forgotten_password) === null || _p === void 0 ? void 0 : _p.link_text}
              </Anchor>)}
            {props.authView === VIEWS.SIGN_IN ? (<Anchor href="#auth-sign-up" onClick={function (e) {
                    e.preventDefault();
                    handleViewChange(VIEWS.SIGN_UP);
                }} appearance={props.appearance}>
                {(_r = (_q = props.i18n) === null || _q === void 0 ? void 0 : _q.sign_up) === null || _r === void 0 ? void 0 : _r.link_text}
              </Anchor>) : (<Anchor href="#auth-sign-in" onClick={function (e) {
                    e.preventDefault();
                    handleViewChange(VIEWS.SIGN_IN);
                }} appearance={props.appearance}>
                {(_t = (_s = props.i18n) === null || _s === void 0 ? void 0 : _s.sign_in) === null || _t === void 0 ? void 0 : _t.link_text}
              </Anchor>)}
          </Container>)}
      </Container>
      {message && <Message appearance={props.appearance}>{message()}</Message>}
      {error && (<Message color="danger" appearance={props.appearance}>
          {error()}
        </Message>)}
    </form>);
}
export { EmailAuth };
